<div class="form-check puggles-form-radio-button d-flex">
    <input type="radio" [name]="name()"
        id="{{ name() }}{{ id() }}"
        class="form-check-input puggles-form-radio-button-input"
        [class.checked]="checked()"
        (change)="optionChanged.emit(value())">
    <div class="d-flex flex-column gap-3">
        <label class="form-check-label puggles-form-radio-button-label fs-6 fw-semi-bold" for="{{ name() }}{{ id() }}">{{ label() }}</label>
        <span class="fs-6">{{ text() }}</span>
    </div>
</div>
